
export type RequestRefundBody = {
  amount: number;
  orderId: string;
  reason?: string;
};
